import React, { useState, useEffect } from "react";
import {
    Button, Card, Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import axiosInstance from "Api";
import { useParams } from "react-router-dom";
import moment from "moment";
import cx from "classnames";
import { ReactComponent as RoundPlus } from "../../../../../assets/utils/images/svgs/RoundPlus.svg";
import { ReactComponent as Save } from "../../../../../assets/utils/images/svgs/save_two.svg";
import { ReactComponent as Small_Arrow } from "../../../../../assets/utils/images/svgs/Small_Arrow.svg";
import { Form, Formik } from "formik";
import { ErrorMessage } from "formik";
import * as Yup from "yup";
import MentionInput from '../../../../../Components/MentionInput/index.js'
import TextLimit from "Api/TextLimit";
import CommonService from "Api/Common";
import useSWR from "swr";
import { useApiMutation } from "services/useApiMutation";


const Chat = ({ substitutionComments, setSubstitutionComments, substitution, mutateSubstitution }) => {
    const [message, setMessage] = useState("");
    const [isEmpty, setIsEmpty] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const params = useParams();
    const substitutionId = params.id || '';
    const [isShrink, setIsShrink] = useState(true);
    const [isSmall, setIsSmall] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [absentsData, setAbsentsData] = useState([]);
    const [formDataState, setFormDataState] = useState({
        message: '',
    });
    const validationSchema = Yup.object().shape({
        message: Yup.string().required("veld is verplicht"),
    });
    const { trigger: addCommentTrigger, isMutating } = useApiMutation();

    const onChangeMessage = (value) => {
        setMessage(value);
        setIsEmpty(false);
    }
    useEffect(() => {

        const schoolId = substitution?.result_info?.school?.iSchoolId;
        const communityId = substitution?.result_info?.school?.community?.iCommunityId;

        if (!schoolId || !communityId) return;

        CommonService.absentData(schoolId, communityId)
            .then(res => {
                const userData = Array.isArray(res.data?.data)
                    ? res.data.data
                    : [];

                userData.forEach(element => {
                    element.name = TextLimit.AfwezigeLimitOptionOne(
                        element.vFirstName,
                        element.vMiddleName,
                        element.vLastName
                    );
                });

                setAbsentsData(userData);
            })
            .catch(err => {
                console.error("Failed to load mention users", err);
            });
    }, [substitution?.result_info?.school?.iSchoolId, substitution?.result_info?.school?.community?.iCommunityId]);


    const sanitizeMessage = (text = "") => {
        return text
            .replace(/\[([^\]]+)\]/g, '$1')
            .replace(/@@(\d+)\|([^@]+)@@/g, '@$2')
            .replace(/\n+/g, ' ')
            .replace(/(@[^\s]+)\s+@/g, '$1 @')
            .replace(/^\s+|\s+$/g, '')
            .replace(/\s+$/, '')
            .trim();
    };
    const handleSubmit = () => {
        setIsDisabled(true);
        if (message.trim().length) {
            const cleanedText = sanitizeMessage(message);
            const msg = {
                text: cleanedText,
                substitution: substitutionId,
                user: "melder",
            }

            addCommentTrigger(() =>
                axiosInstance.post(
                    `substitutions/${substitutionId}/comments`,
                    msg
                )
            )
                .then(async (response) => {

                    if (response.status === "success") {
                        setIsOpen(false)
                        await mutateSubstitution();
                        // setSubstitutionComments([...substitutionComments, response.message])
                        setMessage("")
                        setFormDataState({ ...formDataState, message: '' })

                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(() => {
                    setIsDisabled(false);
                });

        } else {
            setIsEmpty(true)
        }
    }

    return (
        <Card className={cx("app-inner-layout__sidebar chatbox-fixed chat-box-styling melder-chatbox-scroll", { "position-absolute height-100 end-0": !isShrink }, { "w-50": isSmall })} >
            <div className="app-inner-layout__sidebar-inner d-flex flex-column overflow-hidden coor-chat-memo-box">
                <div className="chat-box-header">
                    <div className="mx-2 d-flex align-items-center">

                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <Button size="sm" outline className="me-4 btn-color-style opmerking-chat-btn" color="primary" onClick={() => setIsOpen(true)}>
                            <RoundPlus className="me-1"/>
                            Opmerking
                        </Button>
                    </div>
                </div>

                <div className="scroll-area-lg">
                    <PerfectScrollbar>
                        <div className="p-1 ">
                            <div className="chat-wrapper p-1 d-flex flex-column-reverse melder-chatbox-heigth">
                                {
                                    substitutionComments.map((msg) => {
                                        const uniqueKey = msg.id || msg.iTimestamp;
                                        return (
                                            <div key={uniqueKey} className="chat-box-wrapper mb-3">
                                                <div>
                                                    <small className="opacity-6 text-capitalize">
                                                        <span className="fw-bold me-1 chat-time">{moment(msg.iTimestamp * 1000).format("DD-MM-YYYY")}</span>
                                                        <span class="me-2 chat-time">{moment(msg.iTimestamp * 1000).format("HH:mm")}</span>
                                                        {msg.vMelderName}
                                                    </small>
                                                    <div className="chat-box text-pre-wrap ">
                                                        {msg.vDirComments}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </PerfectScrollbar>
                </div>
            </div>
            <Modal id={"tooltip"} isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} className="modal-dialog__over feedback-modal-style opmerking-modal-styling">
                <ModalHeader>
                    <div className="modal-header-styling">
                        Opmerking
                    </div>
                    <div className="cross-icon-color">
                        <i className="nav-link-icon lnr-cross m-1 cursor-pointer" onClick={() => setIsOpen(false)}> </i>
                    </div>
                </ModalHeader>

                <ModalBody className="d-flex bg-white rounded">
                    <Formik
                        enableReinitialize
                        initialValues={formDataState}
                        validationSchema={validationSchema}
                        onSubmit={
                            (values, { setSubmitting }) => handleSubmit(values, setSubmitting)}
                    >
                        {({

                            handleSubmit,
                        }) => (
                            <Form onSubmit={handleSubmit}>
                                <div className="form-style opmerking-input-styling">
                                    <MentionInput
                                        value={formDataState.message || ''}
                                        onChange={(newValue) => {

                                            setFormDataState({ ...formDataState, message: newValue });
                                            onChangeMessage(newValue);
                                        }}
                                        absentsData={absentsData || []}
                                        placeholder={"Typ hier uw opmerking.\nGebruik @ om iemand te vermelden"}
                                    />
                                </div>

                                <ErrorMessage name="message" component="small" className="block mt-2 invalid-feedback" />
                                <ModalFooter>
                                    <Button className="d-flex align-items-center btn-color-style  opslaan-btn" size="sm" outline color="primary" disabled={isMutating} type="submit">
                                        <Save />
                                        Opslaan
                                    </Button>
                                    <Button className="d-flex align-items-center btn-color-style back-btn" size="sm" outline color="primary" onClick={() => setIsOpen(false)}>
                                        <Small_Arrow />
                                        Terug
                                    </Button>
                                </ModalFooter>
                            </Form>
                        )}
                    </Formik>
                </ModalBody>

            </Modal>
        </Card>
    );
}

export default Chat;
